'use strict';

var repeaterHooks = require('./hooks/repeaterHooks');

module.exports = {
  repeaters: repeaterHooks
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/RMIHooks/componentsHooks.js